<template>
    <div class="fs-form">
        
        <fsForm @submit="set_password" name="Passwort vergessen" :formData="formData" :action="action_url"/>
    </div>
</template>

<script>
import fullscreenForm from "@/components/fullscreenForm"
import Parse from 'parse'
import {toast} from '@/utils/interactions'

export default {
    components: {
        fsForm: fullscreenForm
    },
    methods: {
        set_password() {
            this.$router.push('/login');
        },
    },
    mounted() {

    },
    computed: {
        action_url() {
            var base = Parse.serverURL;
            var router_query = this.$router.history.current.query;
            return base + '/apps/' + router_query.id + '/request_password_reset';
        },
    },
    data() {
        var self = this;
        var router_query = this.$router.history.current.query;
        return {
            formData: {
                username: {
                    type: "hidden",
                    value: router_query.username
                },
                'utf-8': {
                    type: "hidden",
                    value: "✓"
                },
                token: {
                    type: "hidden",
                    value: router_query.token
                },
                new_password: {
                    type: "password",
                    label: "Lege ein sicheres Passwort fest",
                    descr: "Ein sicheres Passwort besitzt Groß- und Kleinbuchstaben, Sonderzeichen und ist mindestens 8 Zeichen lang.",
                    placeholder: "Uer%gho442ar",
                    required: true,
                    validation(value) {
                        return value.length > 7;
                    }
                },
                confirm_new_password: {
                    type: "password",
                    label: "Bestätigen Sie Ihr Passwort",
                    required: true,
                    validation(value) {
                        return self.formData.new_password.value == value;
                    }
                }
            }
        }
    },
}
</script>

<style lang="scss">
    .fs-form {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: $primary-color;
    }
</style>



// WEBPACK FOOTER //
// src/pages/set-password.vue